import * as React from 'react';
import { withRouter, Link, Redirect } from 'react-router-dom';
import bindAllOfThis from "src/utils/BindThisHelper"; // 'this' binder
import Routes from 'src/core/Routes';
import { Translate, withLocalize, LocalizeContextProps } from 'react-localize-redux';
import { PageProps } from 'src/models/common/ComponentProps';

import DataTable, {
    DataTableColumnProps,
    Renderer,
    Filterer,
    DataTableButton,
    DataTableButtonReset
} from 'src/components/common/DataTable';

import TableRequestDTO from 'src/models/datatable/TableRequestDTO';
import TableResponseDTO from 'src/models/datatable/TableResponseDTO';
import ClassroomDTO from 'src/models/classroom/ClassroomDTO';
import ClassroomApiController from 'src/api/ClassroomApiController';
import { Button, Modal, message, Tooltip } from 'antd';


interface ClassroomsProps extends PageProps<{}>, LocalizeContextProps { }

interface ClassroomsState {
    loading: boolean;
    tableRecords: ClassroomDTO[];
    formRedirect: boolean;
}

class Classrooms extends React.Component<ClassroomsProps, ClassroomsState> {
    private dataTableRef: DataTable<ClassroomDTO>;

    constructor(props: ClassroomsProps) {
        super(props);
        bindAllOfThis(this, Classrooms.prototype);

        this.state = {
            tableRecords: [],
            loading: true,
            formRedirect: false
        };
    }

    private deleteClassroom(classroomId: number): void {
        let ref = this.dataTableRef;
        let translate: (id: any) => any = this.props.translate;

        Modal.confirm({
            title: translate('admin.classrooms.confirmDelete'),
            okText: translate('admin.common.confirmYes'),
            okType: 'danger',
            cancelText: translate('admin.common.confirmNo'),
            onOk() {
                ClassroomApiController.deleteClassroom(classroomId).then(result => {
                    message.success(translate('admin.classrooms.messageDelete'));
                    ref.refresh();
                }).catch(e => {
                    message.error(this.props.translate('admin.classrooms.messageDeleteError'));
                });
            },
        });
    }

    private fetchData(requestState: TableRequestDTO, checkEcho: () => boolean, callback: (response: TableResponseDTO<ClassroomDTO>) => void): void {
        this.setState({ loading: true });

        ClassroomApiController.getClassroomTableData(requestState)
            .then(results => {
                if (!checkEcho()) {
                    return;
                }

                let tableRecords = results.data.results ? results.data.results : [];

                this.setState({
                    tableRecords: tableRecords,
                    loading: false
                });

                callback(results.data);
            });
    }

    private customTableColumns(): DataTableColumnProps<ClassroomDTO>[] {
        let editLink = (text, record: ClassroomDTO) => Routes.getRoute(Routes.ADMIN_ADD_EDIT_CLASSROOM, record.classroomId);
        let reportLink = (text, record: ClassroomDTO) => Routes.getRoute(Routes.ADMIN_REPORT_CLASSROOM, record.classroomId);

        return [
            DataTable.StandardColumns.Text('admin.classrooms.columnHeader1', 'classroomName'),
            DataTable.StandardColumns.Link('admin.common.reportColumnHeader', 'report', reportLink, 'download'),
            DataTable.StandardColumns.Link('admin.common.editColumnHeader', 'edit', editLink, 'edit'),
            {
                columnProps: {
                    key: 'delete',
                    align: 'center',
                    width: 35,
                    render: (text, record, index) => {
                        return (
                            <Tooltip placement="bottom" title={this.props.translate('admin.common.deleteColumnHeader')} arrowPointAtCenter>
                                <Button shape="circle" icon="delete" onClick={() => this.deleteClassroom(record.classroomId)} />
                            </Tooltip>
                        );
                    }
                }
            }
        ];
    }

    render() {
        if (this.state.formRedirect) {
            return <Redirect to={Routes.ADMIN_ADD_EDIT_CLASSROOM} push />;
        }

        return (
            <div>
                <h2>{this.props.translate('admin.classrooms.tableHeader')}</h2>

                <DataTable
                    ref={ref => this.dataTableRef = ref}
                    serverSide={true}
                    tableProps={{ rowKey: 'classroomId', loading: this.state.loading }}
                    columns={this.customTableColumns()}
                    data={this.state.tableRecords}
                    fetchData={this.fetchData}
                    buttonBar={[
                        new DataTableButton('admin.classrooms.addButton', () => { this.setState({ formRedirect: true }); }),
                        new DataTableButtonReset()
                    ]} />
            </div>
        );
    }
}

export default withLocalize(Classrooms as any) as any;



// WEBPACK FOOTER //
// ./src/pages/admin/Classrooms.tsx